import axios from "axios";

export const getSuperCategoriesSuggestions = (organizationId, lng = "fr") => {
  const requestUrl = `/team/task-super-categories`;

  return axios.get(requestUrl, {
    params: {
      organization: organizationId,
      lng: lng.charAt(0).toUpperCase() + lng.slice(1)
    }
  });
};

export const updateSuperCategorySettings = ({ organization, id, labels }) => {
  const requestUrl = `/team/task-super-category/edit-name`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("id", id);
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);
  formData.append("superCategory", labels.superCategory);

  return axios.post(requestUrl, formData);
};

export const deleteSuperCategorySettings = ({ organization, isForced, id }) => {
  const requestUrl = `/team/task-super-category/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("isForced", isForced);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};

export const saveSuperCategorySettings = ({ organization, labels }) => {
  const requestUrl = `/team/task-super-category/add`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("labelFr", labels.fr);
  formData.append("labelEn", labels.en);
  formData.append("labelNl", labels.nl);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/super-categories.js